/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：代理商客户管理相关接口地址
 */

// 客户列表
export const customerList = '/customer/customer/list'
// 保存客户
export const customerSave = '/customer/customer/save'
// 获取客户详情
export const getCusDetail = '/customer/customer/get-one'
// 删除客户
export const customerDel = '/customer/customer/del'
// 获取客户联系人列表
export const getLinkmanList = '/customer/customer/contact'
// 获取客户联系人
export const getLinkman = '/customer/customer/get-contact-one'
// 保存客户联系人
export const saveLinkman = '/customer/customer/save-contact'
// 删除客户联系人
export const delLinkman = '/customer/customer/del-contact'
// 获取扩展信息选择项
export const getSelectorItem = '/customer/customer/get-selector-item'
// 获取结算周期、对账日列表
export const getSettlementSelectorItem = '/customer/customer/get-settlement-period-date'
// 获取结算周期、对账日列表
export const getConsumptionStatistics = '/customer/customer/consumption-statistics'
// 客户充值
export const recharge = '/customer/customer/recharge'
// 客户充值二维码收款
export const qrRecharge = '/customer/customer/network-pay-code'
// 根据手机号获取客户信息
export const customerListByMobile = '/customer/customer/list-by-mobile'
// 案例、话术分类列表
export const categoryTreeList = '/customer/resource/category-tree-list'
// 案例列表
export const caseList = '/customer/resource/case-list'
// 发送案例图片
export const getShareCaseImages = '/customer/resource/get-share-case-images'
// 话术列表
export const scriptList = '/customer/resource/script-list'
// 话术详情
export const scriptDetail = '/customer/resource/get-script-info'
// 话术保存
export const scriptSave = '/customer/resource/save-script'
// 话术删除
export const scriptDel = '/customer/resource/delete-script'
// 客户回访列表
export const getCustomerVisit = '/customer/visit/index'
// 保存客户回访
export const saveCustomerVisit = '/customer/visit/save-visit'
// 回访下拉选择框参数
export const visitSelectorItem = '/customer/visit/get-selector-item'
// 客户足迹
export const getCustomerFootmark = '/customer/footmark/index'
// 获取客户优惠券
export const getCustomerCouponList = '/customer/customer/get-coupon-list'
// 核销优惠券
export const saveVerification = '/customer/customer/save-verification'



// WEBPACK FOOTER //
// ./src/api/url/customer.js